const POST_GRADING = "/exam/grading";
const LIST_EXAM_FOR_USER = "/exam/paging_search_user";
const DETAIL_FINISH_EXAM = "/exam/by_id";

export const grading = {
  POST_GRADING,
  LIST_EXAM_FOR_USER,
  DETAIL_FINISH_EXAM,
};
